import React from 'react';

const CalenderIcon = () => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6664 2.73438C11.0198 2.73438 11.3064 3.02092 11.3064 3.37438V7.37443C11.3064 7.7279 11.0198 8.01444 10.6664 8.01444C10.3129 8.01444 10.0264 7.7279 10.0264 7.37443V3.37438C10.0264 3.02092 10.3129 2.73438 10.6664 2.73438Z"
      fill="url(#paint0_radial_4176_17382)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.3334 2.73438C21.6868 2.73438 21.9734 3.02092 21.9734 3.37438V7.37443C21.9734 7.7279 21.6868 8.01444 21.3334 8.01444C20.9799 8.01444 20.6934 7.7279 20.6934 7.37443V3.37438C20.6934 3.02092 20.9799 2.73438 21.3334 2.73438Z"
      fill="url(#paint1_radial_4176_17382)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.33307 6.67845C6.79556 6.67845 6.28006 6.89198 5.89999 7.27206C5.51991 7.65213 5.30638 8.16763 5.30638 8.70514V26.0387C5.30638 26.5762 5.51991 27.0917 5.89999 27.4718C6.28007 27.8518 6.79556 28.0654 7.33307 28.0654H24.6666C25.2041 28.0654 25.7196 27.8518 26.0997 27.4718C26.4798 27.0917 26.6933 26.5762 26.6933 26.0387V6.67845H7.33307ZM4.99488 6.36695C5.61501 5.74682 6.45608 5.39844 7.33307 5.39844H27.9733V26.0387C27.9733 26.9157 27.6249 27.7568 27.0048 28.3769C26.3847 28.997 25.5436 29.3454 24.6666 29.3454H7.33307C6.45608 29.3454 5.61501 28.997 4.99488 28.3769C4.37475 27.7568 4.02637 26.9157 4.02637 26.0387V8.70514C4.02637 7.82815 4.37475 6.98708 4.99488 6.36695Z"
      fill="url(#paint2_radial_4176_17382)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.02637 10.0853C4.02637 9.73185 4.31291 9.44531 4.66637 9.44531H27.3333C27.6868 9.44531 27.9733 9.73185 27.9733 10.0853C27.9733 10.4388 27.6868 10.7253 27.3333 10.7253H4.66637C4.31291 10.7253 4.02637 10.4388 4.02637 10.0853Z"
      fill="url(#paint3_radial_4176_17382)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4294 19.1628C12.2395 19.1626 12.0499 19.1801 11.8633 19.2152C11.5159 19.2804 11.1814 19.0517 11.1161 18.7043C11.0509 18.3569 11.2796 18.0224 11.627 17.9571C11.8921 17.9074 12.1613 17.8825 12.431 17.8828L12.4302 18.5228V17.8828C12.4304 17.8828 12.4307 17.8828 12.431 17.8828C14.4227 17.8832 16.2119 19.2854 16.2119 21.2145C16.2119 23.0913 14.4844 24.722 12.4382 24.7262C12.4408 24.7262 12.4435 24.7261 12.4462 24.726L12.4302 24.0862V24.7262C12.4328 24.7262 12.4355 24.7262 12.4382 24.7262C11.8059 24.7406 11.1812 24.5871 10.6276 24.2811C10.0717 23.9739 9.60765 23.5242 9.28324 22.9781C9.1027 22.6742 9.20269 22.2815 9.50658 22.101C9.81046 21.9204 10.2032 22.0204 10.3837 22.3243C10.592 22.6749 10.8898 22.9636 11.2467 23.1608C11.6036 23.358 12.0066 23.4566 12.4142 23.4464C12.4195 23.4463 12.4248 23.4462 12.4302 23.4462C13.8538 23.4462 14.9319 22.3087 14.9319 21.2145C14.9319 20.1706 13.9081 19.1628 12.4302 19.1628L12.4294 19.1628Z"
      fill="url(#paint4_radial_4176_17382)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.18848 15.1088C9.18848 14.7553 9.47502 14.4688 9.82848 14.4688H15.2119C15.4707 14.4688 15.7041 14.6247 15.8032 14.8638C15.9022 15.103 15.8475 15.3783 15.6644 15.5613L12.1877 19.038C11.9378 19.288 11.5326 19.288 11.2826 19.038C11.0327 18.7881 11.0327 18.3829 11.2826 18.1329L13.6668 15.7488H9.82848C9.47502 15.7488 9.18848 15.4622 9.18848 15.1088Z"
      fill="url(#paint5_radial_4176_17382)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.9841 14.1896C22.1876 14.3024 22.3139 14.5167 22.3139 14.7494V24.0828C22.3139 24.4363 22.0274 24.7228 21.6739 24.7228C21.3204 24.7228 21.0339 24.4363 21.0339 24.0828V15.9042L19.1414 17.0871C18.8417 17.2745 18.4468 17.1834 18.2595 16.8836C18.0721 16.5839 18.1632 16.1891 18.463 16.0017L21.3347 14.2067C21.532 14.0834 21.7806 14.0768 21.9841 14.1896Z"
      fill="url(#paint6_radial_4176_17382)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_4176_17382"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11.6277 9.39782) rotate(-103.569) scale(7.97369 12.3726)"
      >
        <stop stopColor="#E60000" />
        <stop offset={1} stopColor="#9C2AA0" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_4176_17382"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(22.2947 9.39782) rotate(-103.569) scale(7.97369 12.3726)"
      >
        <stop stopColor="#E60000" />
        <stop offset={1} stopColor="#9C2AA0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_4176_17382"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(33.984 35.6195) rotate(-134.873) scale(49.6055 168.747)"
      >
        <stop stopColor="#E60000" />
        <stop offset={1} stopColor="#9C2AA0" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_4176_17382"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(33.984 11.0607) rotate(-176.927) scale(35.0489 12.7661)"
      >
        <stop stopColor="#E60000" />
        <stop offset={1} stopColor="#9C2AA0" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_4176_17382"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(17.9735 26.5204) rotate(-135.593) scale(14.3586 48.835)"
      >
        <stop stopColor="#E60000" />
        <stop offset={1} stopColor="#9C2AA0" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_4176_17382"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(17.5244 20.4717) rotate(-144.358) scale(11.9834 38.6095)"
      >
        <stop stopColor="#E60000" />
        <stop offset={1} stopColor="#9C2AA0" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_4176_17382"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(23.356 27.5036) rotate(-111.278) scale(16.7204 38.4692)"
      >
        <stop stopColor="#E60000" />
        <stop offset={1} stopColor="#9C2AA0" />
      </radialGradient>
    </defs>
  </svg>

  )
}

export default CalenderIcon;